const ru = {
    microspec: "Микроспек",
    goBackToHome: "Вернуться на главную",
    signIn: "Войти",
    optional: "Необязательно",
    userSettings: "Настройки пользователя",
    users: "Пользователи",
    // Branch management translations
    branches: "Филиалы",
    manageBranches: "Управление филиалами",
    addBranch: "Добавить филиал",
    loadingBranches: "Загрузка филиалов...",
    editBranch: "Редактировать филиал",
    branchName: "Название филиала",
    branchNameRequired: "Название филиала *",
    branchNameIsRequired: "Название филиала обязательно",
    branchNotFound: "Филиал не найден",
    failedToLoadBranch: "Не удалось загрузить данные филиала",
    failedToSaveBranch: "Не удалось сохранить филиал",
    branchUpdatedSuccessfully: "Филиал успешно обновлен!",
    branchCreatedSuccessfully: "Филиал успешно создан!",
    updateBranchInfo: "Обновить информацию и настройки филиала",
    fillBranchDetails: "Заполните данные для создания нового филиала",
    updateBranch: "Обновить филиал",
    createBranch: "Создать филиал",
    location: "Местоположение",
    address: "Адрес",
    city: "Город",
    state: "Штат/область",
    zipCode: "Почтовый индекс",
    country: "Страна",
    contactInformation: "Контактная информация",
    emailAddress: "Адрес электронной почты",
    phoneNumber: "Номер телефона",
    manageUsers: "Управление пользователями",
    logout: "Выйти",
    account: "Аккаунт",
    security: "Безопасность",
    firstName: "Имя",
    lastName: "Фамилия",
    password: "Пароль",
    phone: "Номер телефона",
    save: "Сохранить",
    saving: "Сохранение...",
    dangerZone: "Опасная зона",
    dangerZoneDeleteAccountText: "Нажмите кнопку ниже, чтобы удалить аккаунт",
    // Login method selection
    selectLoginMethod: "Выберите способ входа",
    selectRegistrationMethod: "Выберите способ регистрации",
    chooseLoginMethod: "Выберите способ входа",
    email: "Эл. почта",
    loginError: "Ошибка входа, пожалуйста, попробуйте снова",
    languages: "Языки",
    notifications: "Уведомления",
    noNewNotifications: "Нет новых уведомлений",
    getResetLinkAfterButtonClick: "Нажмите кнопку ниже, чтобы получить ссылку для сброса пароля на электронную почту",
    getResetLink: "Получить ссылку для сброса пароля",
    passwordReset: "Сброс пароля",
    simpleElementText: "Давайте создадим отличную страницу с помощью основ Microspec",
    pleaseWait: "Пожалуйста, подождите",
    deleteAccount: "Удалить аккаунт",
    cancel: "Отмена",
    confirm: "Подтвердить",
    emailOrPasswordInvalid: "Неверная электронная почта или пароль",
    rememberMe: "Запомнить меня",
    forgotPassword: "Забыли пароль?",
    newAccount: "Новый аккаунт?",
    signUp: "Зарегистрироваться",
    joinUsToday: "Присоединяйтесь к нам сегодня",
    signUpError: "Произошла ошибка, возможно, электронная почта уже зарегистрирована или пароль не соответствует требованиям безопасности, пожалуйста, попробуйте снова.",
    signUpInProgress: "Создание аккаунта...",
    resetLinkSuccessfullySent: "Ссылка для сброса пароля успешно отправлена на вашу электронную почту.",
    errorTryLater: "Произошла ошибка, извините за беспокойство, попробуйте позже.",
    new: "Новое",
    newUnreadNotifications: "У вас {0} новых уведомлений",
    deleteAccountConfirmationDialogText: "Пожалуйста, подтвердите удаление аккаунта",
    notificationsWaitMessage: "Пожалуйста, подождите, пока загружаются уведомления",
    viewAll: "Показать все",
    invalidPhone: "Неверный номер телефона",
    invalidAddress: "Неверный адрес",
    aboutYourself: "Расскажите о себе",
    welcomeBack: "С возвращением",
    loggingInProgress: "Вход в систему...",
    formProgress: "Прогресс формы",
    additionalInformation: "Дополнительная информация",
    // New authentication translations
    signingIn: "Вход в систему...",
    verificationCode: "Код подтверждения",
    otpSentMessage: "Код подтверждения отправлен на ваш телефон",
    verifyAndSignIn: "Подтвердить и войти",
    verifying: "Подтверждение...",
    resendOtp: "Отправить код повторно",
    sendingOtp: "Отправка...",
    resendOtpIn: "Отправить код повторно через {seconds} секунд",
    // Profile completion
    completeYourProfile: "Завершите ваш профиль",
    profileCompletionDescription: "Пожалуйста, введите ваше имя и фамилию для завершения регистрации",
    firstNameRequired: "Имя обязательно",
    lastNameRequired: "Фамилия обязательна",
    completeProfile: "Завершить профиль",
    creatingProfile: "Создание профиля...",
    registrationEmail: "Email:",
    registrationPhone: "Телефон:",
    back: "Назад",
    backToEmailSelection: "Назад к выбору электронной почты",
    backToPhoneSelection: "Назад к выбору телефона",
    userNotFound: "Пользователь не найден. Пожалуйста, проверьте ваши данные.",
    errorCheckingUser: "Ошибка при проверке пользователя. Пожалуйста, попробуйте еще раз.",
    invalidCredentials: "Неверная электронная почта или пароль",
    enterYourPassword: "Введите ваш пароль",
    enterVerificationCode: "Введите отправленный код подтверждения",
    // Email verification translations
    verifyEmail: "Подтвердите свой адрес электронной почты",
    verificationEmailSent: "Мы отправили письмо для подтверждения на",
    checkEmailInstructions: "Пожалуйста, проверьте свою электронную почту и нажмите на ссылку для подтверждения, чтобы продолжить.",
    resendVerification: "Отправить письмо для подтверждения еще раз",
    verificationEmailResent: "Письмо для подтверждения было успешно отправлено еще раз!",
    verificationEmailError: "Не удалось отправить письмо для подтверждения. Пожалуйста, попробуйте еще раз.",
    checkVerificationStatus: "Я подтвердил свой адрес электронной почты",
    checkingVerificationStatus: "Проверка статуса подтверждения...",
    checking: "Проверка...",
    sending: "Отправка...",
    sentSuccessfully: "Успешно отправлено",
    emailVerified: "Адрес электронной почты подтвержден!",
    emailVerifiedMessage: "Ваш адрес электронной почты был успешно подтвержден. Перенаправление...",
    didntReceiveEmail: "Не получили письмо?",
    checkSpamFolder: "Проверьте папку со спамом или нажмите «Отправить еще раз» выше.",
    backToLogin: "← Назад к входу",
    tryDifferentEmail: "Попробовать другой адрес электронной почты →",
    // 404 Page translations
    notFoundTitle: "Упс! Заблудились в цифровом пространстве",
    notFoundSubtitle: "Страница, которую вы ищете, унесло в цифровую пустоту. Не волнуйтесь, даже лучшие исследователи иногда сворачивают не туда!",
    notFoundBackToHome: "Вернуться на главную",
    notFoundTryAgain: "Попробовать снова",
    notFoundQuickNavigation: "Быстрая навигация",
    notFoundErrorCode: "Ошибка 404",
    notFoundPageLabel: "Страница не найдена",
    notFoundHome: "Главная",
    dragNDrop: "Перетащите файлы сюда или нажмите, чтобы выбрать файлы",
    // Authentication error messages
    failedToSendOtp: "Не удалось отправить код подтверждения. Пожалуйста, попробуйте еще раз.",
    failedToSendVerificationCode: "Не удалось отправить код подтверждения. Пожалуйста, попробуйте еще раз.",
    failedToCreateProfile: "Не удалось создать профиль. Пожалуйста, попробуйте еще раз.",
    userAuthenticationMissing: "Информация аутентификации пользователя отсутствует",
    noConfirmationResult: "Результат подтверждения не найден. Пожалуйста, попробуйте еще раз.",
    // Loader messages
    loadingInitialData: "Загрузка начальных данных...",
    loadingApplicationData: "Загрузка данных приложения...",
    loadingUserProfile: "Загрузка профиля пользователя...",
    // Registration messages
    createNewAccount: "Создать новый аккаунт",
    createNewPasswordDescription: "Создайте новый пароль для вашего аккаунта",
    enterNewPassword: "Введите новый пароль",
    confirmNewPassword: "Подтвердите новый пароль",
    newAccountCreationNotice: "Новый аккаунт будет создан с этим адресом электронной почты",
    passwordRequirements: "Пароль должен содержать не менее 8 символов",
    creatingAccount: "Создание аккаунта...",
    createAccount: "Создать аккаунт",
    registrationError: "Регистрация не удалась. Пожалуйста, попробуйте еще раз.",
    passwordRequired: "Пароль обязателен",
    passwordTooShort: "Пароль должен содержать не менее 8 символов",
    passwordsDoNotMatch: "Пароли не совпадают",
    emailAlreadyInUse: "Этот адрес электронной почты уже зарегистрирован. Пожалуйста, попробуйте войти в систему.",
    invalidEmail: "Неверный адрес электронной почты",
    newAccountAutoCreationNoticeForEmail: "Если нет аккаунта, связанного с этим адресом электронной почты, вам будет предложено создать новый аккаунт, и вы получите инструкции по процессу регистрации",
    newAccountAutoCreationNoticeForPhone: "Если нет аккаунта, связанного с этим номером телефона, вам будет предложено создать новый аккаунт, и вы получите инструкции по процессу регистрации",
    // Phone registration messages
    // Account form translations
    updateYourAccountInfo: "Обновите информацию вашего аккаунта и настройки",
    personalInformation: "Личная информация",
    fieldRequired: "Это поле обязательно",
    pleaseFixErrors: "Пожалуйста, исправьте ошибки перед отправкой",
    profileUpdatedSuccessfully: "Профиль успешно обновлен!",
    verifiedField: "Это поле подтверждено и не может быть изменено",
    // Profile picture translations
    changeProfilePicture: "Изменить фото профиля",
    selectProfilePicture: "Выбрать фото профиля",
    selectImageDescription: "Выберите изображение для загрузки в качестве фото профиля. Вы сможете обрезать и настроить его перед сохранением.",
    clickToUpload: "Нажмите для загрузки",
    selectImage: "Выбрать изображение",
    cropYourImage: "Обрезать изображение",
    uploadingProfilePicture: "Загрузка фото профиля...",
    profilePictureUpdated: "Фото профиля успешно обновлено!",
    failedToUpdateProfilePicture: "Не удалось обновить фото профиля. Пожалуйста, попробуйте еще раз.",
    invalidFileType: "Пожалуйста, выберите файл изображения",
    fileTooLarge: "Размер файла должен быть менее 10MB",
    selectDifferent: "Выбрать другое",
    saveProfilePicture: "Сохранить фото профиля",
    // Generic image upload translations
    uploadImage: "Загрузить изображение",
    imageUploadedSuccessfully: "Изображение успешно загружено!",
    failedToUploadImage: "Не удалось загрузить изображение. Пожалуйста, попробуйте еще раз.",
    uploadingImage: "Загрузка изображения...",
    saveImage: "Сохранить изображение",
    changeProfilePictureDescription: "Выберите изображение для загрузки в качестве фото профиля. Вы сможете обрезать и настроить его перед сохранением.",
    // Logo upload translations
    uploadLogo: "Загрузить логотип",
    changeLogo: "Изменить логотип",
    uploadLogoDescription: "Выберите изображение для загрузки в качестве логотипа. Вы сможете обрезать и настроить его перед сохранением.",
    logo: "Логотип",
    // User existence messages
    userAlreadyExists: "Этот аккаунт уже существует. Пожалуйста, войдите в систему.",
    userNotFoundPleaseRegister: "Аккаунт с такой информацией не найден. Пожалуйста, сначала зарегистрируйтесь.",
    dashboard: "Панель управления",
    systemAdminDashboard: "Панель управления системного администратора",
    // Organization management translations
    organizationName: "Название организации",
    organizationDescription: "Описание организации",
    organizations: "Организации",
    manageOrganization: "Управление организациями",
    addOrganization: "Добавить организацию",
    editOrganization: "Редактировать организацию",
    loadingOrganization: "Загрузка организации...",
    noOrganizationFound: "Организации не найдены.",
    loadMore: "Загрузить еще",
    createFirstOrganization: "Создать первую организацию",
    createOrganization: "Создать организацию",
    // UpsertOrganization component
    organizationNotFound: "Организация не найдена",
    failedToLoadOrganization: "Не удалось загрузить данные организации",
    basicInformation: "Основная информация",
    organizationNameRequired: "Название организации *",
    industry: "Отрасль",
    selectIndustry: "Выберите отрасль",
    description: "Описание",
    organizationDescriptionPlaceholder: "Введите краткое описание вашей организации...",
    emailAddressRequired: "Адрес электронной почты *",
    branding: "Брендинг",
    remove: "Удалить",
    primaryColor: "Основной цвет",
    secondaryColor: "Дополнительный цвет",
    settings: "Настройки",
    primaryCurrency: "Основная валюта",
    supportedCurrencies: "Поддерживаемые валюты",
    localization: "Локализация",
    language: "Язык",
    preferredLanguage: "Предпочитаемый язык",
    supportedLanguages: "Поддерживаемые языки",
    updateOrganizationInfo: "Обновить информацию об организации и настройки",
    fillOrganizationDetails: "Заполните детали для создания новой организации",
    organizationUpdatedSuccessfully: "Организация успешно обновлена!",
    organizationCreatedSuccessfully: "Организация успешно создана!",
    organizationNameIsRequired: "Название организации обязательно",
    contactEmailIsRequired: "Контактный email обязателен",
    pleaseEnterValidEmail: "Пожалуйста, введите действительный адрес электронной почты",
    pleaseEnterValidPhone: "Пожалуйста, введите действительный номер телефона",
    pleaseEnterValidHexColor: "Пожалуйста, введите действительный hex цвет",
    pleaseSelectImageFile: "Пожалуйста, выберите файл изображения",
    imageSizeLessThan5MB: "Размер изображения должен быть менее 5MB",
    pleaseFixFormErrors: "Пожалуйста, исправьте ошибки формы перед отправкой",
    userNotAuthenticated: "Пользователь не аутентифицирован",
    systemError: "Системная ошибка. Пожалуйста, попробуйте позже.",
    organizationInfoMissing: "Информация об организации отсутствует.",
    organizationOwnershipInfoMissing: "Информация о владельце организации не настроена.",
    unauthorized: "У вас нет разрешения на доступ к этой странице.",
    verificationError: "Произошла ошибка при проверке вашего доступа. Пожалуйста, попробуйте снова.",
    accessDenied: "Доступ запрещен",
    failedToSaveOrganization: "Не удалось сохранить организацию",
    updating: "Обновление...",
    updateOrganization: "Обновить организацию",
    creating: "Создание...",
    restaurant: "Ресторан",
    technology: "Технологии",
    healthcare: "Здравоохранение",
    finance: "Финансы",
    education: "Образование",
    retail: "Розничная торговля",
    manufacturing: "Производство",
    construction: "Строительство",
    foodAndBeverage: "Еда и напитки",
    transportation: "Транспорт",
    realEstate: "Недвижимость",
    marketing: "Маркетинг",
    consulting: "Консалтинг",
    other: "Другое",
    arabicSaudi: "Арабский (Саудовская Аравия)",
    hebrewIsrael: "Иврит (Израиль)",
    englishUS: "Английский (США)",
    pageNotFound: "Страница не найдена",
    pageNotFoundText: "Страница, которую вы ищете, не существует.",
    yearsOfExperience: "Лет опыта",
    invalidOtp: "Неверный код подтверждения",
    otpVerificationFailed: "Проверка кода не удалась",
    failedToResendOtp: "Не удалось повторно отправить код",
    emailRegistrationNotAvailable: "Регистрация по электронной почте недоступна",
    otpSentSuccessfully: "Код подтверждения успешно отправлен",
    id: "ID",
    internalId: "Внутренний ID",
    createdAt: "Создано",
    updatedAt: "Обновлено",
    unnamedOrganization: "Безымянная организация",
    noDescriptionProvided: "Описание не предоставлено",
    loadingDashboard: "Загрузка панели управления...",
    brandingStatistics: "Статистика брендинга",
    withLogos: "С логотипами",
    withBranding: "С брендингом",
    currencyStatistics: "Статистика валют",
    totalCurrenciesSupported: "Всего поддерживаемых валют",
    activityOverview: "Обзор активности",
    organizationsLastMonth: "Организаций создано за прошлый месяц",
    ofTotal: "от общего количества",
    currenciesBreakdown: "Разбивка по валютам",
    totalOrganization: "Всего организаций",
    totalUsers: "Всего пользователей",
    of: "из",
    rowsPerPage: "Количество строк на страницу",
    search: "Поиск",
    noSearchResults: "Результаты поиска не найдены",
    items: "элементы",
    noDataAvailable: "Нет доступных данных",
    actions: "Действия",
    refresh: "Обновить",
    export: "Экспорт",
    columnSettings: "Настройки столбцов",
    selected: "выбрано",
    moreThan: "более чем",
    exportData: "Экспорт данных",
    exportFormat: "Формат экспорта",
    exportScope: "Область экспорта",
    currentPage: "Текущая страница",
    pageRange: "Диапазон страниц",
    allPages: "Все страницы",
    fromPage: "Со страницы",
    toPage: "До страницы",
    exportInfo: "Информация об экспорте",
    // Organization Context
    workspaceContext: "Контекст рабочей области",
    selectOrganization: "Выберите организацию",
    selectBranch: "Выберите филиал",
    allBranches: "Все филиалы",
    currentContext: "Текущий контекст",
    noOrganizationMembership: "Не являетесь членом какой-либо организации",
    noOrganizationMembershipDescription: "Вам нужно быть приглашенным в организацию для доступа к этой панели управления.",
    loadingOrganizationContext: "Загрузка контекста рабочей области...",
    retry: "Повторить",
    roles: "роли",
    nextSteps: "Следующие шаги",
    contactOrganizationAdmin: "Связаться с администратором организации",
    contactOrganizationAdminDescription: "Обратитесь к администратору вашей организации для запроса доступа.",
    waitForInvitation: "Дождитесь приглашения",
    waitForInvitationDescription: "После приглашения вы сможете получить доступ к панели управления и ее функциям.",
    checkForMemberships: "Проверить членство",
    organizationsManager: "Менеджер организаций",
    // UpsertMemberToOrganization component
    assignMemberToOrganization: "Добавить участника в организацию",
    findUser: "Найти пользователя",
    assignRoles: "Назначить роли",
    organizationIdRequired: "Требуется ID организации",
    failedToValidateIds: "Не удалось проверить ID организации/филиала",
    pleaseEnterSearchValue: "Пожалуйста, введите адрес электронной почты или номер телефона",
    failedToSearchUser: "Не удалось найти пользователя",
    pleaseSelectUser: "Пожалуйста, выберите пользователя",
    pleaseSelectAtLeastOneRole: "Пожалуйста, выберите хотя бы одну роль",
    failedToAssignMember: "Не удалось назначить участника",
    memberAlreadyInBranch: "Участник уже существует в выбранном филиале",
    memberAssignedSuccessfully: "Участник успешно назначен",
    userAddedToOrgAndBranch: "Пользователь добавлен в организацию и филиал с выбранными ролями.",
    userAddedToOrg: "Пользователь добавлен в организацию с выбранными ролями.",
    addAnotherMember: "Добавить еще участника",
    close: "Закрыть",
    findUserToAdd: "Найти пользователя для добавления",
    searchByEmail: "Поиск по email",
    searchByPhone: "Поиск по телефону",
    searchByEmailOrPhone: "Поиск по email или телефону",
    searchResults: "Результаты поиска",
    selectRolesForMember: "Выберите роли, которые вы хотите назначить этому участнику.",
    organizationRoles: "Роли организации",
    branchRoles: "Роли филиала",
    confirmAssignment: "Подтвердить назначение",
    user: "Пользователь",
    memberWillReceiveNotification: "Участник получит уведомление о своей новой роли.",
    assignMember: "Назначить участника",
    next: "Далее",
    validatingInformation: "Проверка информации...",
    userAlreadyOrgMember: "Этот пользователь уже является активным участником этой организации",
    userAlreadyOrgMemberCanAddToBranch: "Этот пользователь уже является участником организации и будет добавлен в выбранный филиал",
    userAlreadyBranchMember: "Этот пользователь уже является активным участником этого филиала",
    selectOrganizationAndBranch: "Выберите организацию и филиал",
    selectBranchOptional: "Выберите филиал (необязательно)",
    pleaseSelectOrganization: "Пожалуйста, выберите организацию",
    failedToLoadOrganizations: "Не удалось загрузить организации",
    userWillBeAssignedToBranch: "Пользователь будет назначен в выбранную организацию и филиал",
    userWillBeAssignedToOrg: "Пользователь будет назначен только в выбранную организацию",
    selectedUser: "Выбранный пользователь",
    userFound: "Пользователь найден",
    identifier: "Идентификатор",
    authenticationMethod: "Метод аутентификации",
    availableMethods: "Доступные методы",
    errorSearchingUser: "Ошибка при поиске пользователя. Пожалуйста, попробуйте еще раз.",
    // ManageMembers component
    branchMembers: "Участники филиала",
    organizationMembers: "Участники организации",
    noBranchesFound: "Филиалы не найдены",
    unnamedBranch: "Безымянный филиал",
    memberAddedSuccessfully: "Участник успешно добавлен",
    memberSuspended: "Участник успешно приостановлен",
    memberActivated: "Участник успешно активирован",
    memberRemoved: "Участник успешно удален",
    failedToUpdateMember: "Не удалось обновить участника",
    failedToRemoveMember: "Не удалось удалить участника",
    member: "Участник",
    manageMembers: "Управление участниками",
    status: "Статус",
    noRoles: "Роли не назначены",
    active: "Активный",
    suspended: "Приостановлен",
    invited: "Приглашен",
    transferred: "Переведен",
    joinedAt: "Присоединился",
    notYetJoined: "Еще не присоединился",
    addedOn: "Добавлен",
    addMember: "Добавить участника",
    suspend: "Приостановить",
    activate: "Активировать",
    noMembers: "Участники не найдены",
    suspendMember: "Приостановить участника",
    activateMember: "Активировать участника",
    suspendMemberConfirm: "Вы уверены, что хотите приостановить этого участника? Он потеряет доступ к организации/филиалу.",
    activateMemberConfirm: "Вы уверены, что хотите активировать этого участника? Он восстановит доступ к организации/филиалу.",
    removeMember: "Удалить участника",
    removeMemberWarning: "Это действие необратимо. Участник будет удален навсегда.",
    removeMemberConfirm: "Вы уверены, что хотите удалить этого участника?",
    processing: "Обработка...",
    unknownUser: "Неизвестный пользователь",
    loading: "Загрузка...",
    ecommerceBusinessManager: "Менеджер электронной коммерции",
    manageModules: "Управление модулями",
    modules: "Модули",
    addModule: "Добавить модуль",
    enablableModules: "Включаемые модули",
    manageSystemModules: "Включайте или отключайте системные модули для настройки платформы",
    enabled: "Включено",
    disabled: "Отключено",
    organizationContextAware: "Учитывает контекст организации",
    noEnablableModules: "Нет включаемых модулей",
    noModulesAvailable: "В настоящее время нет доступных модулей для включения или отключения",
    enableModule: "Включить модуль",
    disableModule: "Отключить модуль",
    enableModuleConfirmation: "Это включит модуль на 14 дней. Модуль будет доступен для вашей организации в течение этого периода.",
    disableModuleConfirmation: "Это немедленно отключит модуль. Пользователи больше не смогут получить доступ к функциям этого модуля.",
    module: "Модуль",
    activePeriod: "Активный период",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    // Module access control translations
    moduleNotEnabled: "Модуль не включен",
    moduleNotEnabledDescription: "Этот модуль в настоящее время не включен для вашей организации. Пожалуйста, свяжитесь с администратором для включения доступа к этой функции.",
    requestedModule: "Запрошенный модуль",
    currentOrganization: "Текущая организация",
    moduleEnableInstructions: "Если вы хотите получить доступ к этому модулю, пожалуйста, свяжитесь с администратором вашей организации для его включения.",
    goToModules: "Перейти к модулям",
    goBack: "Назад",
    // Organizational Layout translations
    loadingOrganizationData: "Загрузка данных организации...",
    illegalState: "Недопустимый запрос",
    illegalStateDescription: "Для отображения содержимого этой страницы требуется действительная информация об организации. Пожалуйста, зайдите на эту страницу через соответствующую навигацию.",
    organizationNotFoundDescription: "Организация, которую вы ищете, не существует или была удалена. Пожалуйста, проверьте идентификатор организации и попробуйте снова.",
    branchNotFoundForOrganization: "Филиал не найден",
    branchNotFoundForOrganizationDescription: "Запрашиваемый филиал не существует в этой организации. Возможно, он был удален или идентификатор филиала неверен.",
    unexpectedError: "Что-то пошло не так",
    unexpectedErrorDescription: "Произошла непредвиденная ошибка при загрузке данных организации. Пожалуйста, попробуйте позже или обратитесь в службу поддержки, если проблема не исчезнет.",
    // Permissions Management translations
    permissionsManagement: "Управление разрешениями",
    permissionsManagementDescription: "Просмотр и синхронизация системных разрешений с базой данных",
    manageAuthentication: "Управление аутентификацией",
    filterByModule: "Фильтр по модулю",
    filter: "Фильтр",
    allModules: "Все модули",
    synced: "Синхронизировано",
    notSynced: "Не синхронизировано",
    syncAll: "Синхронизировать все",
    syncing: "Синхронизация...",
    syncToDatabase: "Синхронизировать с базой данных",
    permissionId: "ID разрешения",
    displayName: "Отображаемое имя",
    total: "Всего",
    // Permission names
    manageOrganizationsPermission: "Управление организациями",
    manageOrganizationsPermissionDesc: "Создание, редактирование и удаление организаций",
    manageUsersPermission: "Управление пользователями",
    manageUsersPermissionDesc: "Создание, редактирование и управление учетными записями",
    manageModulesPermission: "Управление модулями",
    manageModulesPermissionDesc: "Включение или отключение системных модулей",
    managePermissionsPermission: "Управление разрешениями",
    managePermissionsPermissionDesc: "Настройка и назначение разрешений",
    manageProductsPermission: "Управление продуктами",
    manageProductsPermissionDesc: "Создание, редактирование и управление каталогом продуктов",
    manageOrdersPermission: "Управление заказами",
    manageOrdersPermissionDesc: "Просмотр и обработка заказов клиентов",
    viewAnalyticsPermission: "Просмотр аналитики",
    viewAnalyticsPermissionDesc: "Доступ к бизнес-аналитике и отчетам",
    manageCustomersPermission: "Управление клиентами",
    manageCustomersPermissionDesc: "Просмотр и управление информацией о клиентах",
    noPermissionsFound: "Разрешения не найдены",
    all: "Все",
    createdWithLove: "Создано с любовью ❤️ компанией Microspec",
    copyrightsReserved: "Все права защищены",
    learnMore: "Узнать больше",
    faqTitle: "Часто задаваемые вопросы",
    faqSubtitle: "Найдите ответы на распространенные вопросы о наших услугах",
    faqSearchPlaceholder: "Поиск вопроса...",
    noFaqSearchResults: "Результаты поиска по часто задаваемым вопросам не найдены",
    lightMode: "Светлый режим",
    darkMode: "Темный режим",
    contactUs: "Связаться с нами",
    submit: "Отправить",
    clear: "Очистить",
    formSuccessMessage: "Форма успешно отправлена!",
    fullName: "Полное имя",
    message: "Сообщение",
    // Localized Input
    localizedInputManageLocalizations: "Управление переводами",
    localizedInputClickIconToLocalize: "Нажмите значок языка для перевода на все языки",
    localizedInputEditAllLanguages: "Редактировать значения для всех поддерживаемых языков",
    localizedInputPreferred: "Предпочтительный",
    localizedInputEnterValue: "Введите значение",
}

const getRussianMap = () => {
    return ru
}

export default getRussianMap
